import React, {useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Navbar from './components/Navbar';
import CommentSection from './components/CommentSection';
import NotFoundPage from './components/NotFoundPage';
import 'katex/dist/katex.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/monokai.css';
import StreamingChat from "./components/StreamComment";
import CreatePersona from "./components/CreatePersona";
import PersonaRenderer from "./components/PersonaRenderer";
import PersonaList from './components/PersonaList';
import UpdatePersonaPage from './components/UpdatePersonaPage';
import PersonaSelectionPage from './components/PersonaSelectionPage';
import SessionListPage from './components/SessionListPage';
import ConversationInterface from './components/ConversationInterface';
import AssetTestPage from './components/AssetTestPage';

function App() {
    useEffect(() => {
        hljs.highlightAll();
    }, []);

    const handleAddResponse = (response: string) => {
        // Do something with the complete response
        console.log("Complete response:", response);
    };

    return (
        <Router>
            <Navbar/>
            <Routes>
                {/* New persona-based routes */}
                <Route path="/" element={<PersonaSelectionPage/>}/>
                <Route path="/persona/:personaId" element={<SessionListPage/>}/>
                <Route path="/chat/:personaId/:sessionId" element={<ConversationInterface/>}/>
                
                {/* Legacy routes for backward compatibility */}
                <Route path="/topic/:topicId/:topicMsg" element={<CommentSection/>}/>
                <Route path="/personas" element={<PersonaList/>}/>
                <Route path="/create-persona" element={<CreatePersona/>}/>
                <Route path="/asset-test" element={<AssetTestPage/>}/>
                <Route path="/updatePersona/:personaName/:author/:version"
                       element={<UpdatePersonaPage/>}/>
                <Route path="/page" element={<CommentSection/>}/>
                <Route path="/stream" element={<StreamingChat handleAddResponse={handleAddResponse}/>}/>
                <Route path="/persona/:personaName/:author/:version" element={<PersonaRenderer/>}/>
                
                {/* Catch all for 404 */}
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Router>
    );
}

export default App;
